import { Component } from 'react';
//import PropTypes from 'prop-types';
//import { GeckoFieldModel } from '../../../';

class GeckoFieldBase extends Component {

	handleChange(event) {
		return this.props.handler.bind(this, this.field().key, this.prepareValue(event.target.value))();
	}

	handleBlur(event) {
		if (this.props.field.onBlur) return this.props.field.onBlur(event);
		return;
	}

	prepareValue(value) {
		return value;
	}

	// prepareJsonValue(key, value) {
 //        let _value = this.jsonValue();
 //        _value[key] = value;
 //        return _value;
 //    }

	field() {
		return this.props.field;
	}

	config() {
		return this.field().config || {};
	}

	value() {
		// get nested object values from a key like 'nested.object.value' to target {nested: {object: {value: 'test'}}}
		const keyFragments = this.field().key.split('.');
		const getValue = (obj, key) => obj[key];
		return keyFragments.reduce(getValue, this.props.values);
	}

	name() {
		return this.field().name;
	}

	// jsonValue() {
 //        if (this.value() && typeof this.value() === 'object') return this.value();
 //        // Default value
 //        let value = {};
 //        (this.inputs || []).forEach(input => value[input.key] = '');
 //        return value;
 //    }

	renderId() {
		return `field_${this.field().key}`;
	}

	renderAriaLabel() {
		return this.field().label;
	}

	isDisabled() {
		return this.field().disabled || (this.field().disabledWhen ? this.field().disabledWhen() : false);
	}

	options() {
		return this.field().options && Array.isArray(this.field().options) ? this.field().options : [];
	}

	attributes()
	{
		return this.field().attributes ? this.field().attributes : {};
	}

	ref() {
		return this.field().ref ? this.field().ref : null;
	}
	
}

export default GeckoFieldBase;